<div class="page-container">
	<div class="page-body-container">
		<div class="inner-content w-full">
			<div class="card w-full">
				<div class="card-header-container">
					<h1 class="card-header">Bestellhistorie</h1>
				</div>
				<div class="card-content" *ngIf="payments && payments.length > 0">
					<table mat-table [dataSource]="dataSource">
						<ng-container matColumnDef="invoicenumber">
							<th mat-header-cell *matHeaderCellDef> Rechnungsnummer </th>
							<td mat-cell *matCellDef="let element"> {{element.invoiceNumber}} </td>
						</ng-container>

						<ng-container matColumnDef="status">
							<th mat-header-cell *matHeaderCellDef> Status </th>
							<td mat-cell *matCellDef="let element">
								<ng-container [ngSwitch]="element.status">
									<span *ngSwitchCase="'pending'">
										Austehend
									</span>
									<span *ngSwitchCase="'paid/paypal'">
										Bezahlt mit PayPal
									</span>
									<span *ngSwitchCase="'paid/prepayment'">
										Bezahlt mit Vorkasse
									</span>
									<span *ngSwitchCase="'paid/finalized'">
										abgeschlossen
									</span>
								</ng-container>
							</td>
						</ng-container>

						<ng-container matColumnDef="price">
							<th mat-header-cell *matHeaderCellDef> Nettopreis </th>
							<td mat-cell *matCellDef="let element"> {{element.totalNetAmount | currency:'EUR'}} </td>
						</ng-container>

						<ng-container matColumnDef="vat">
							<th mat-header-cell *matHeaderCellDef> Steuer </th>
							<td mat-cell *matCellDef="let element"> {{element.totalTaxAmount | currency:'EUR'}} </td>
						</ng-container>

						<ng-container matColumnDef="total">
							<th mat-header-cell *matHeaderCellDef> Gesamtsumme</th>
							<td mat-cell *matCellDef="let element"> {{element.totalGrossAmount | currency:'EUR'}} </td>
						</ng-container>

						<ng-container matColumnDef="invoice">
							<th mat-header-cell *matHeaderCellDef> Rechnung</th>
							<td mat-cell *matCellDef="let element">
								<a *ngIf="element.invoice.data"
								   [href]="element.invoice.data | safeUrl:'data:application/pdf;base64,'"
								   download="rechnung.pdf">
									Download
								</a>
								<span *ngIf="!element.invoice.data">
									In Kürze verfügbar
								</span>
							</td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
						<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
					</table>

					<mat-paginator [pageSizeOptions]="[10, 20, 50]"
								   [pageSize]="currentPageOptions.pageSize"
								   [pageIndex]="currentPageOptions.page - 1"
								   [length]="currentPageOptions.totalCount"
								   showFirstLastButtons
								   (page)="paginatorChange($event)"
								   aria-label="Seite auswählen">
					</mat-paginator>
				</div>
			</div>
		</div>
	</div>
</div>
